import {IToJson} from '@toolify/client/src/types/IToJson'
import {mapFileResponseInstance} from '@toolify/client/src/modules/api/singletons/mapFileResponseInstance'
import {
  ICloudItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICloudItemResponseInstance'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'

export function mapCloudItemResponseInstance(
  cloudItem: IToJson<ICloudItemResponseInstance>,
): ICloudItemResponseInstance {
  return {
    ...cloudItem,
    file: mapFileResponseInstance(cloudItem.file),
    createdAt: new Date(cloudItem.createdAt),
    updatedAt: new Date(cloudItem.updatedAt),
    movedToTrashAt: new Date(cloudItem.movedToTrashAt),
    authorEntity: mapResponseEntity(cloudItem.authorEntity),
  }
}
